export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/as-profile-default-avatar.29fa21d5.svg","height":100,"width":100};